import type { AdminStats } from "../types";

export function KpiCards({ stats }: { stats: AdminStats | null }) {
  const cards = [
    { label: "Total Registrations", value: stats?.total_users ?? "-", color: "from-[#5716a8] to-[#985ae6]", icon: "⚽", bg: "bg-purple-50", borderColor: "rgba(87,22,168,0.2)" },
    { label: "Winners Selected", value: stats?.total_winners ?? "-", color: "from-amber-400 to-amber-600", icon: "🏆", bg: "bg-amber-50", borderColor: "rgba(251,191,36,0.2)" },
    { label: "Wards Covered", value: stats?.total_cities ?? "-", color: "from-blue-500 to-blue-600", icon: "📍", bg: "bg-blue-50", borderColor: "rgba(59,130,246,0.2)" },
    { label: "New (7 days)", value: stats?.recent_registrations ?? "-", color: "from-purple-500 to-purple-600", icon: "📈", bg: "bg-purple-50", borderColor: "rgba(168,85,247,0.2)" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.label} className={`${card.bg} rounded-xl shadow-sm border p-5 flex items-center gap-4 hover:shadow-md transition-shadow`} style={{ borderColor: card.borderColor }}>
          <div className={`bg-gradient-to-br ${card.color} w-12 h-12 rounded-xl flex items-center justify-center text-xl text-white shadow-sm`}>
            {card.icon}
          </div>
          <div>
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">{card.label}</p>
            <p className="text-2xl font-bold text-gray-900">{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
